import Styles from './Header.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { ScheduledPostStatusTag } from 'components/ScheduledPostStatusTag/ScheduledPostStatusTag'
import { usePostPreviewContext } from 'components/PostPreviewModal/PostPreviewContext'

export const Header = () => {
  const { channel, scheduledPost } = usePostPreviewContext()

  return (
    <div className={Styles.header}>
      <div className={Styles.channel}>
        <ChannelIcon channel={channel} size={32} />
        <Heading level={3}>Post Preview</Heading>
      </div>
      {scheduledPost && (
        <div className={Styles.status}>
          <ScheduledPostStatusTag scheduledPostId={scheduledPost?.id} articleId={scheduledPost?.source_id} />
        </div>
      )}
    </div>
  )
}
